import React from 'react';
import config from '../config/config';
import {i18n_get_value, I18N_LABELS} from '../i18n/i18n_scripts';
import '../style/warning.css';

export default class PageNotFound extends React.Component {
    render() {
        let homeUrl = config.homeUrl;
        return (
            <div className="page-wrap">
                <div className="container">
                    <div className="message animated bounceIn">
                        <div className="display-table">
                            <div className="display-table-cell">
                                <svg className="icon icon-left icon-x"></svg>
                            </div>
                            <div className="display-table-cell">
                                <h1>{i18n_get_value(I18N_LABELS.PAGE_NOT_FOUND_ERROR_TITLE)}</h1>
                                <h2>{i18n_get_value(I18N_LABELS.PAGE_NOT_FOUND_ERROR_SUB_TITLE)}</h2>
                                <p>{i18n_get_value(I18N_LABELS.PAGE_NOT_FOUND_ERROR_GO_BACK)} <a href={homeUrl}>{i18n_get_value(I18N_LABELS.PAGE_NOT_FOUND_ERROR_PAGE_NAME_LINK)}</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
